export const navigationLinks = [
    { to: '/', labelKey: 'navigation.home' },
    { to: '/services', labelKey: 'navigation.services' },
    { to: '/products', labelKey: 'navigation.products' },
    { to: '/contact', labelKey: 'navigation.contact' }
];
export const footerNavigationLinks = [
    ...navigationLinks,
    { to: '/downloads', labelKey: 'footer.downloads' }
];
export const legalLinks = [
    { to: '/legal', labelKey: 'footer.legal' },
    { to: '/privacy', labelKey: 'footer.privacy' },
    { to: '/cookies', labelKey: 'footer.cookies' },
    { to: '/terms', labelKey: 'footer.terms' },
    { to: '/refund-policy', labelKey: 'footer.refunds' }
];
